import type { FileRecord } from "@cohesive/api-client";
import { MoreHorizontal } from "lucide-react";

/**
 * Trailing slot for canvas file rows: a single hover-revealed kebab
 * button that opens the same context menu the row's right-click would.
 *
 * Routing the click through the parent's context-menu handler keeps
 * primary/secondary affordances in one place — Files-list rows get
 * "Locate" + "Delete file" (with confirm), section-view rows get
 * "Locate" + "Remove from canvas". The trailing component itself stays
 * presentational; per-list semantics live in `CanvasScope`'s
 * `openFileRowContextMenu`.
 */
export function CanvasFileRowTrailing({
  record,
  onOpenMenu,
}: {
  record: FileRecord;
  onOpenMenu: (e: React.MouseEvent, record: FileRecord) => void;
}) {
  return (
    <button
      type="button"
      aria-label="More actions"
      title="More actions"
      onClick={(e) => {
        e.stopPropagation();
        onOpenMenu(e, record);
      }}
      // dnd-kit's draggable listeners live on the row; pointerdown
      // bubbling into them would arm a drag whenever the user clicked
      // the kebab. Stop both pointer + click propagation here.
      onPointerDown={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      className="inline-flex h-6 w-6 items-center justify-center rounded-md text-muted-foreground hover:bg-n-10 hover:text-foreground opacity-0 group-hover:opacity-100 focus-visible:opacity-100 pointer-events-auto"
    >
      <MoreHorizontal className="h-3.5 w-3.5" />
    </button>
  );
}
